module.exports = {
    resolution: {width:1024, height:768},
    loadscreen: {
        loadbar:{
            position:{x:262, y:662}
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 11
// module chunks = 0